import { createContext, useContext, useState, ReactNode } from 'react'
import { ConsultationContext } from '../services/geminiService'

interface GeminiContextContextType {
  consultationContext: ConsultationContext | null
  setConsultationContext: (context: ConsultationContext | null) => void
}

const GeminiContextContext = createContext<GeminiContextContextType | undefined>(undefined)

export function GeminiContextProvider({ children }: { children: ReactNode }) {
  const [consultationContext, setConsultationContext] = useState<ConsultationContext | null>(null)

  return (
    <GeminiContextContext.Provider
      value={{
        consultationContext,
        setConsultationContext,
      }}
    >
      {children}
    </GeminiContextContext.Provider>
  )
}

export function useGeminiContext() {
  const context = useContext(GeminiContextContext)
  if (context === undefined) {
    throw new Error('useGeminiContext must be used within a GeminiContextProvider')
  }
  return context
}






























